import React from 'react'

import { Card, IconButton, CloseIcon } from '@paypalcorp/pp-react'
import FeedbackReason from './FeedbackReason'

const Feedback = ({
  answerId,
  searchID,
  closeDialog,
  setIsFeedbackOpen,
  setFeedbackSent,
}: {
  answerId: string
  searchID: string
  closeDialog: () => void
  setIsFeedbackOpen: React.Dispatch<React.SetStateAction<boolean>>
  setFeedbackSent: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  return (
    <Card>
      <IconButton
        buttonType="tertiary"
        size="xs"
        svgIconComponent={CloseIcon}
        onClick={closeDialog}
        style={{ float: 'right' }}
      />

      <FeedbackReason
        answerId={answerId}
        searchID={searchID}
        setIsFeedbackOpen={setIsFeedbackOpen}
        setFeedbackSent={setFeedbackSent}
      />
    </Card>
  )
}

export default Feedback
